import React from "react";
import { formatCountdown } from "../../utils/timeUtils";
import "./PrayerCountdown.css";

interface PrayerCountdownProps {
  prayerName: string;
  seconds: number;
  textColor?: string;
}

const PrayerCountdown: React.FC<PrayerCountdownProps> = ({
  prayerName,
  seconds,
  textColor,
}) => {
  return (
    <div className="prayer-countdown large">
      <div className="prayer-countdown-timer" style={{ color: textColor }}>
        {formatCountdown(seconds)}
        {/* Removed 's' unit as requested */}
      </div>
    </div>
  );
};

export default PrayerCountdown;
